import React from 'react';
import './Home.js'; // Create this file OR move styles to App.css

const Home = () => (
  <div className="home-container">
    <div className="home-card">
      <div className="profile-section">
        <img
          src="https://img.icons8.com/clouds/150/000000/user.png"
          alt="Dhvaj Arvindbhai Patel"
          className="profile-pic"
        />
        <div>
          <h1>Hi, I'm <span className="highlight">Dhvaj Arvindbhai Patel</span> 👋</h1>
          <p className="subtitle">Aspiring Data Scientist & Artificial Intellgence</p>
        </div>
      </div>

      <div className="story-section">
        <h2>📖 My Journey</h2>
        <p>
          From a childhood, exploring the world to a passionate Data Science learner,
          my journey has always been about understanding how things work and making them better.
        </p>
      </div>

      <div className="reason-section">
        <h2>💡 Why I Chose IT ?</h2>
        <p>
          Because, Technology gives me the tools to create, solve problems, and bring ideas to life.
          I believe IT is not just a career, but a way to transform imagination into impact.it's my future goal.
        </p>
      </div>

    </div>
  </div>
);

export default Home;
